// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8413) return "static/chunks/0fe94c24-8114504a690c5be3.js";
	if (chunkId === 6163) return "static/chunks/6163-3da630d1ecc4a968.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"1435":"24c877fe980a2ee4","2477":"c7db6dc6d59b0d41","5279":"68774277ed16bccf","7229":"eed2072bf61581bf"}[chunkId] + ".js";
};